var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { Component } from "react";
import { get } from "lodash";
import posed, { PoseGroup } from "react-pose";
import styled from "styled-components";
import GetMessagesAnonChat from "@irati/insights/apollo/query/Chatroom/Messages";
import { Expander, Message } from "./";
var MessageList = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column-reverse;\n"], ["\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var Item = posed.div({
    enter: { height: "auto", transition: { duration: 200 } },
    exit: { height: "1px", transition: { duration: 300 } }
});
var POLL_INTERVAL = 5000;
var Messages = /** @class */ (function (_super) {
    __extends(Messages, _super);
    function Messages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            folded: null,
            lastFoldedUuid: null
        };
        _this.filterMessages = function (messages) {
            var _a = _this.state, folded = _a.folded, lastFoldedUuid = _a.lastFoldedUuid;
            var lastIndex = messages.length - 2;
            if (folded && messages.length) {
                if (!lastFoldedUuid) {
                    return [messages[0], messages[lastIndex + 1]];
                }
                else {
                    var filteredMessages_1 = [];
                    messages.forEach(function (message, i) {
                        if (message.uuid === lastFoldedUuid) {
                            filteredMessages_1 = __spreadArrays([messages[0]], messages.slice(i + 1));
                        }
                    });
                    return filteredMessages_1;
                }
            }
            return messages;
        };
        return _this;
    }
    Messages.prototype.render = function () {
        var _this = this;
        var roomUuid = this.props.roomUuid;
        var _a = this.state, folded = _a.folded, lastFoldedUuid = _a.lastFoldedUuid;
        return (React.createElement(GetMessagesAnonChat, { fetchPolicy: "network-only", pollInterval: roomUuid ? POLL_INTERVAL : 0, roomUuid: roomUuid, onCompleted: function (_a) {
                var _b = _a.insMessages, results = _b.results, count = _b.count;
                _this.setState({
                    folded: folded === null ? count > 2 : folded,
                    lastFoldedUuid: count > 2 ? lastFoldedUuid || results[results.length - 2].uuid : null
                });
            } }, function (_a) {
            var messagesData = _a.data;
            var messages = get(messagesData, "insMessages.results", []);
            var filteredMessages = _this.filterMessages(messages);
            return (React.createElement(MessageList, null,
                React.createElement(PoseGroup, null, filteredMessages.slice().reverse().map(function (message, index) {
                    return (React.createElement(Item, { key: message.uuid },
                        React.createElement(Message, { message: message }),
                        folded && index === filteredMessages.length - 1 && (React.createElement(Expander, { onClick: function () { return _this.setState({ folded: false }); }, count: messages.length - filteredMessages.length }))));
                }))));
        }));
    };
    return Messages;
}(Component));
export default Messages;
var templateObject_1;
